<template>
  <div>
    <div class="plTitle">零工评价</div>
    <div class="plTxt dis-cent">
      <div class="txt">下单时间：{{ time }}</div>
    </div>
    <div class="content">
      <div class="cont">
        <div class="cpBox">
          <div class="img">
            <img :src="$imgUrl + memberInfo.avatars" alt="" />
          </div>
          <div class="name">{{ memberInfo.member_info.realname }}</div>
        </div>
        <div class="contBox">
          <div class="box">
            <div class="name">零工评分</div>
            <div class="starBox">
              <div
                @mouseenter="mouseover(index)"
                @mouseleave="mouseout(index)"
                @click="cpClick(index)"
                class="iconfont"
                :class="
                  index >= setarData.on
                    ? 'icon-collection'
                    : 'icon-collection_fill on'
                "
                v-for="(item, index) in setarData.setar"
              ></div>
              <div class="txt">{{ setarData.on }}分</div>
            </div>
          </div>
          <div class="box">
            <div class="name" style="margin-top: 8px">评价晒单</div>
            <div class="funBox">
              <div class="textVal">
                <textarea
                  name=""
                  id=""
                  placeholder="快来分享体验心得~"
                  v-model="setarData.xinde"
                ></textarea>
              </div>
              <div class="upImg">
                <div class="imgs">
                  <div
                    class="img"
                    @click="uploadFile()"
                    v-if="setarData.imgList.length < 9"
                  >
                    <div class="imgBox iconfont icon-camera_fill"></div>
                  </div>
                  <div class="img" v-for="(item, index) in setarData.imgList">
                    <img :src="$imgUrl + item.path_name" />
                    <div
                      class="iconfont icon-close close"
                      @click="imgDelClick(index)"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="saveCont dis-cent">
      <div class="saveBtn dis-cent" @click="plClick">发表评价</div>
    </div>
    <input
      type="file"
      accept="image/*"
      ref="fileInput"
      @change="onFileChange"
      style="display: none"
    />
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      list: [
        {
          name: "2",
          qd: 0,
          on: 0,
          setar: 5,
          imgList: [],
        },
      ],
      setarData: {
        qd: 0,
        on: 0,
        setar: 5,
        imgList: [],
      },
      imgI: 0,
      info: {},
      carlist: [],
      memberInfo: {
        member_info: {},
      },
      time: "",
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.member_id = this.$route.query.member_id;
    this.time = this.$route.query.time;
    // this.get();
    this.infoget();
  },
  methods: {
    infoget() {
      this.$get("/nozzle/web/member_odd_get", {
        id: this.member_id,
      }).then((res) => {
        console.log(res);
        this.memberInfo = res.member;
      });
    },
    get() {
      this.$get("/nozzle/web/order_get", {
        id: this.id,
      }).then((res) => {
        console.log(res);
        for (let i = 0; i < res.carlist.length; i++) {
          const e = res.carlist[i];
          e.qd = 0;
          e.on = 0;
          e.setar = 5;
          e.imgList = [];
        }
        this.$forceUpdate();
        this.carlist = res.carlist;
        this.info = res.data;
      });
    },
    imgDelClick(i) {
      this.setarData.imgList.splice(i, 1);
    },
    async uploadFile(i) {
      this.imgI = i;
      this.$refs.fileInput.click();
    },
    onFileChange(e) {
      var formData = new FormData();
      console.log(e.target.files);
      formData.append("file", e.target.files[0]);
      formData.append("where", "product");
      this.$uploadfile("/common/fileupload", formData).then((res) => {
        console.log(res);
        if (res.data.status) {
          this.setarData.imgList.push(res.data.data);
        } else {
          this.$message.error("网络繁忙,请稍后再试~");
        }
      });
    },
    mouseover(i) {
      this.setarData.on = i + 1;
    },
    mouseout() {
      if (!this.setarData.qd) {
        this.setarData.on = 0;
      } else {
        this.setarData.on = this.setarData.qd;
      }
    },
    cpClick(i) {
      this.setarData.qd = i + 1;
      this.setarData.on = i + 1;
    },
    plClick() {
      let data = {};
      let imgId = [];
      for (let j = 0; j < this.setarData.imgList.length; j++) {
        const ej = this.setarData.imgList[j];
        imgId.push(ej.id);
      }
      data.content = this.setarData.xinde;
      data.resource = imgId.join(",");
      data.to_member_id = Number(this.member_id);
      data.order_id = Number(this.id);
      data.score = Number(this.setarData.on)*20;
      if (!data.score) {
        this.$message.error("请对产品打分");
        return;
      }
      if (!data.content) {
        this.$message.error("请填写评价内容");
        return;
      }
      console.log(data);
      data = JSON.stringify(data);
      this.$post("/nozzle/web/odd_evaluate", {
        data: data,
      }).then((res) => {
        console.log(res);
        this.visible = false;
        if (res.data.status) {
          this.$message.success('评价成功');
          this.$router.go(-1)
        } else {
          this.$message.warning(res.data.msg);
        }
      });
    },
    urlTz() {
      let url = "/chuantian/#/orderCont?id=" + this.id;
      const newWindow = window.open(url, "_blank");
      if (newWindow) {
        // 尝试关闭当前窗口
        window.close();
        // 如果当前窗口未关闭，则在新窗口打开目标页面并关闭当前页面
        if (!window.closed) {
          newWindow.focus();
        }
      } else {
        // 如果打开新窗口失败（如被浏览器拦截），则在当前窗口跳转
        window.location.href = url;
      }
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.plTitle {
  font-weight: 900;
  font-size: 16px;
  text-align: center;
  margin-top: 25px;
}

.plTxt {
  margin-top: 5px;
  .txt {
    margin-right: 20px;
  }
  .txt:last-child {
    margin-right: 0;
  }
}

.content {
  width: 1440px;
  margin: auto;
  background-color: white;
  border-radius: 5px;
  margin-top: 30px;
  .cont {
    border-bottom: 1px solid #ebebeb;
    display: flex;
    .cpBox {
      width: 400px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      border-right: 1px solid #ebebeb;
      padding: 10px 0;
      .img {
        width: 150px;
      }
      .name {
        margin-top: 10px;
        color: #666;
      }
    }
    .contBox {
      width: calc(100% - 40px);
      box-sizing: border-box;
      padding: 20px 30px;
      .box {
        display: flex;
        margin-bottom: 20px;
        .name {
          width: 150px;
          height: 30px;
          line-height: 30px;
        }
        .starBox {
          width: calc(100% - 150px);
          display: flex;
          align-items: center;
          .iconfont {
            font-size: 20px;
            color: #c9c9c9;
            cursor: pointer;
          }
          .on {
            color: #e23;
          }
          .txt {
            margin-left: 10px;
            margin-top: -2px;
            color: #9c9c9c;
          }
        }
        .funBox {
          width: calc(100% - 150px);
          .textVal {
            width: 100%;
            border-radius: 5px;
            border: 1px solid #ebebeb;
            overflow: hidden;
            box-sizing: border-box;
            textarea {
              border: none;
              width: 100%;
              height: 150px;
              padding: 10px 15px;
            }
          }
          .upImg {
            margin-top: 10px;

            .text {
              margin-left: 20px;
              font-size: 12px;
            }

            .txt {
              margin-left: 5px;
              font-size: 12px;
              color: #999;
            }

            .imgs {
              display: flex;
              margin-top: 15px;
              flex-wrap: wrap;

              .img {
                width: calc(10% - 9px);
                margin-right: 10px;
                padding-top: calc(10% - 9px);
                position: relative;
                overflow: unset;
                .imgBox {
                  width: 100%;
                  position: absolute;
                  top: 0;
                  left: 0;
                  height: 100%;
                  border-radius: 5px;
                  box-shadow: 0 0 4px 2px #ebebeb;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  color: #9c9c9c;
                  font-size: 26px;
                  cursor: pointer;
                }
                img {
                  position: absolute;
                  top: 0;
                  left: 0;
                  border-radius: 5px;
                }

                .close {
                  position: absolute;
                  top: -3px;
                  right: -3px;
                  background-color: #b3b3b3;
                  border-radius: 50%;
                  width: 15px;
                  height: 15px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-size: 10px;
                  color: #fff;
                  cursor: pointer;
                }
              }

              .img:nth-child(5n) {
                margin-right: 0;
              }
            }
          }
        }
      }
      .box:last-child {
        margin-bottom: 10px;
      }
    }
  }
  .cont:last-child {
    border-bottom: none;
  }
}

.saveCont {
  width: 1440px;
  margin: auto;
  background-color: white;
  border-radius: 5px;
  height: 120px;
  margin-top: 25px;
  .saveBtn {
    background-color: rgb(34, 129, 238);
    color: #fff;
    width: 250px;
    height: 55px;
    border-radius: 5px;
    cursor: pointer;
  }
}
</style>
